import { render, staticRenderFns } from "./WebHeader.vue?vue&type=template&id=6b050c76&scoped=true"
import script from "./WebHeader.vue?vue&type=script&lang=js"
export * from "./WebHeader.vue?vue&type=script&lang=js"
import style0 from "./WebHeader.vue?vue&type=style&index=0&id=6b050c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.98.0__ejs@3.1.10_loda_cce3uyf2imv72g6btugowonk4q/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b050c76",
  null
  
)

export default component.exports